import type { ProjectConfiguration } from '@/api/generated/model';
import {
  DEFAULT_REPORT_SUBPRODUCT,
  type ReportSubproduct,
} from '@/domains/reports/utils/report-subproduct.utils';

export function isReportSubproductEnabled(
  subproduct: ReportSubproduct,
  config: Pick<ProjectConfiguration, 'roi_settings' | 'aifi_settings'> | undefined,
): boolean {
  if (subproduct === 'experience') return true;
  if (subproduct === 'roi') return config?.roi_settings?.enabled ?? false;
  if (subproduct === 'aifi') return config?.aifi_settings?.enabled ?? false;
  return true;
}

export function isDisabledBetaReportSubproduct(subproduct: ReportSubproduct): subproduct is 'roi' | 'aifi' {
  return subproduct === 'roi' || subproduct === 'aifi';
}

export function getEffectiveReportSubproduct(
  subproduct: ReportSubproduct,
  config: Pick<ProjectConfiguration, 'roi_settings' | 'aifi_settings'> | undefined,
): ReportSubproduct {
  if (isReportSubproductEnabled(subproduct, config)) return subproduct;
  if (isDisabledBetaReportSubproduct(subproduct)) return DEFAULT_REPORT_SUBPRODUCT;
  return subproduct;
}

export function shouldShowBetaSubproductUpsell(
  subproduct: ReportSubproduct,
  config: Pick<ProjectConfiguration, 'roi_settings' | 'aifi_settings'> | undefined,
): subproduct is 'roi' | 'aifi' {
  return isDisabledBetaReportSubproduct(subproduct) && !isReportSubproductEnabled(subproduct, config);
}
